function AccordionComponent(el) {
    this.el = el;
    this.init();
}

AccordionComponent.prototype.init = function() {
    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsTitle')) {
            this.toggleLine(e.target.parentElement);
        }
    });
};

AccordionComponent.prototype.toggleLine = function(lineEl) {
    if (lineEl.classList.contains('open')) {
        this.closeLine(lineEl);
    } else {
        this.closeAllLines();
        this.openLine(lineEl);
    }
};

AccordionComponent.prototype.openLine = function(lineEl) {
    const contentEl = lineEl.querySelector('.jsContent');

    lineEl.classList.add('open');
    const newContentHeight = contentEl.offsetHeight;
    lineEl.classList.remove('open');

    gsap.timeline()
        .set(contentEl, { height: 0 })
        .add(() => lineEl.classList.add('open'))
        .to(contentEl, { duration: 0.5, height: newContentHeight, ease: 'power2.inOut' })
        .set(contentEl, { clearProps: 'all' })
    ;
};

AccordionComponent.prototype.closeLine = function(lineEl) {
    const contentEl = lineEl.querySelector('.jsContent');
    
    gsap.timeline()
        .to(contentEl, { duration: 0.5, height: 0, ease: 'power2.inOut' })
        .add(() => lineEl.classList.remove('open'))
        .set(contentEl, { clearProps: 'all' })
    ;
};

AccordionComponent.prototype.closeAllLines = function() {
    const lineEls = this.el.querySelectorAll('.jsLine.open');
    for (let i = 0; i < lineEls.length; i++) this.closeLine(lineEls[i]);
};


(function() {
    const accordionEls = document.querySelectorAll('.jsAccordionComponent');
    for (let i = 0; i < accordionEls.length; i++) new AccordionComponent(accordionEls[i]);
})();